// extracted by mini-css-extract-plugin
module.exports = {"imgContainer":"_75088531","modalBody":"_67ae4c2e","heading":"_f0df6d3d","text":"_a8439e48","carouselBody":"_45407635"};